{
  "Data": {
    "BackgroundMedia": {
      "mediaRef": false,
      "imageOverlay": false
    },
    "WixVideo": {
      "posterImageRef": false
    },
    "WixVideoData": {
      "posterImageRef": false
    },
    "Document": {
      "mainPage": false,
      "pages": false,
      "appStudioData": false
    },
    "SiteMembersData": {
      "termsOfUse": {
        "link": false
      },
      "privacyPolicy": {
        "link": false
      },
      "codeOfConduct": {
        "link": false
      }
    },
    "AppStudioData": {
      "widgets": false,
      "customDefinitions": false
    },
    "WidgetDescriptor": {
      "rootCompId": false,
      "variations": false
    },
    "VariationDescriptor": {
      "rootCompId": false
    },
    "Header": {
      "image": false
    },
    "Image": {
      "link": false,
      "originalImageDataRef": false
    },
    "Bgimagestrip": {
      "originalImageDataRef": false
    },
    "StripColumnsContainer": {
      "a11y": false
    },
    "StripContainer": {
      "background": false
    },
    "ImageList": {
      "items": false
    },
    "LinkList": {
      "items": false
    },
    "AnchorLink": {
      "anchorDataId": true,
      "pageId": false
    },
    "PageLink": {
      "pageId": false
    },
    "MediaRichText": {
      "linkList": false,
      "componentDataList": false
    },
    "MenuItem": {
      "refId": false
    },
    "Page": {
      "ogImageRef": false,
      "pageBackgrounds": {
        "desktop": {
          "ref": false
        },
        "mobile": {
          "ref": false
        }
      }
    },
    "RichTextImage": {
      "text": false,
      "image": false
    },
    "Service": {
      "image": false
    },
    "ServiceList": {
      "items": false
    },
    "TextInput": {
      "a11y": false
    },
    "CheckboxInput": {
      "link": false
    },
    "QuickActionBarItem": {
      "link": false
    },
    "BasicMenuItem": {
      "link": false,
      "items": false,
      "iconRef": false
    },
    "CustomMenu": {
      "items": false
    },
    "Menu": {
      "items": false
    },
    "CustomMenusCollection": {
      "menus": false
    },
    "CustomMenuDataRef": {
      "menuRef": false
    },
    "MenuDataRef": {
      "menuRef": false
    },
    "ImageButton": {
      "link": false,
      "defaultImage": false,
      "hoverImage": false,
      "activeImage": false
    },
    "SubscribeForm": {
      "link": false
    },
    "ContactForm": {
      "link": false
    },
    "DynamicContactForm": {
      "link": false
    },
    "FlashComponent": {
      "placeHolderImage": false
    },
    "GeoMapLocation": {
      "link": false
    },
    "GeoMap": {
      "locations": false
    },
    "LinkableFlashComponent": {
      "link": false,
      "placeHolderImage": false
    },
    "LinkableButton": {
      "link": false
    },
    "TinyMenu": {
      "loginSocialBarRef": false
    },
    "LoginSocialBar": {
      "menuItemsRef": false,
      "iconItemsRef": false
    },
    "MenuData": {
      "menuButton": false,
      "pages": false
    },
    "PagesGroupCollection": {
      "groups": false
    },
    "PermaLink": {
      "dataItemRef": false,
      "correctPermaLinkRef": false
    },
    "SelectableList": {
      "options": false
    },
    "RadioGroup": {
      "options": false
    },
    "CheckboxGroup": {
      "options": false
    },
    "StyledText": {
      "linkList": false,
      "a11y": false
    },
    "StyledTextLinkHelper": {
      "link": false
    },
    "SvgShape": {
      "link": false
    },
    "VectorImage": {
      "link": false
    },
    "Table": {
      "items": false,
      "header": false,
      "footer": false
    },
    "Video": {
      "posterImage": false
    },
    "TPAWidget": {
      "tpaData": false
    },
    "TPA": {
      "tpaData": false
    },
    "TPASection": {
      "tpaData": false
    },
    "TPAMultiSection": {
      "tpaData": false
    },
    "RssButton": {
      "image": false,
      "link": false
    },
    "AppPage": {
      "ogImageRef": false,
      "pageBackgrounds": {
        "desktop": {
          "ref": false
        },
        "mobile": {
          "ref": false
        }
      }
    },
    "StripContainerSlideShowSlide": {
      "background": false
    },
    "Repeater": {
      "a11y": false
    },
    "ImageButtonWithText": {
      "icon": false
    },
    "LightboxContainer": {
      "a11y": false
    },
    "ContainerData": {
      "a11y": false
    },
    "MediaBoxData": {
      "a11y": false
    }
  },
  "Design": {
    "MediaContainerDesignData": {
      "background": false
    },
    "MediaPlayerDesignData": {
      "background": false
    },
    "BackgroundMedia": {
      "mediaRef": false,
      "imageOverlay": false
    },
    "WixVideo": {
      "posterImageRef": false
    },
    "Video": {
      "posterImage": false
    },
    "Image": {
      "link": false,
      "originalImageDataRef": false
    },
    "MediaControlsDesignData": {
      "iconsDefaultDesign": false,
      "icons": false
    },
    "ControlIconDesignData": {
      "iconDesign": false
    }
  },
  "Properties": {
    "ColumnProperties": {
      "background": false
    }
  },
  "Style": {
    "StylesInBreakpoint": {
      "stylesInBreakpoints": false
    },
    "RefArray": {
      "values": false
    },
    "BreakpointRelation": {
      "breakpoint": false,
      "ref": false
    }
  }
}
